import { Capacitor } from "@capacitor/core";

/** True inside the iOS or Android app, false on the website. */
export const isNativeApp = Capacitor.isNativePlatform();

/**
 * The public site, for links people share or open elsewhere. The apps' pages
 * load from the device, so their build sets VITE_API_URL (see vite.config.ts).
 */
export const PUBLIC_ORIGIN = (import.meta.env.VITE_API_URL || window.location.origin).replace(
  /\/+$/,
  "",
);

/** Prefix for API requests: the public site in the apps, same-origin on the website. */
export const API_ORIGIN = isNativeApp ? PUBLIC_ORIGIN : "";
